import { Component } from 'react';

interface LifecycleProps {
  onMount?: (instance: Lifecycle) => void;
  onUpdate?: (instance: Lifecycle, prevProps: LifecycleProps) => void;
  onUnmount?: (instance: Lifecycle) => void;
}

class Lifecycle extends Component<LifecycleProps> {
  componentDidMount() {
    if (this.props.onMount) this.props.onMount.call(this, this);
  }

  componentDidUpdate(prevProps: LifecycleProps) {
    if (this.props.onUpdate) this.props.onUpdate.call(this, this, prevProps);
  }

  componentWillUnmount() {
    if (this.props.onUnmount) this.props.onUnmount.call(this, this);
  }

  render() {
    return null;
  }
}

export default Lifecycle;
